export default __webpack_public_path__ + "static/WhyteMediumItalic-682ba379de05409e018012553b6db686.woff";